import { HttpService } from 'core/modules/network-service';

/*************************************************************/
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc ActionWidgetItemDetailSummary defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ActionWidgetItemDetailSummaryService } from 'services/actionWidgetItemDetailSummary';
 *
 * // create service instance and send/cancel request
 * const actionWidgetItemDetailSummaryService = new ActionWidgetItemDetailSummaryService();
 * const result = await actionWidgetItemDetailSummaryService.fetchData( '<user-id>' ); // fetch data
 * actionWidgetItemDetailSummaryService.cancel(); // cancel an active request
 */
export class ActionWidgetItemDetailSummaryService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            const state =  [ get( response, 'body.component.data.state', {} ) ];

            response.body.component.data.state = { items: state };
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component', {} ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }


    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
